import React from 'react';

interface Props {
	size: number;
}

export const SkepticalIcon: React.FC<Props> = props => (
	<svg
		aria-hidden='true'
		className='margin--8'
		height={props.size}
		viewBox='0 0 24 24'
		width={props.size}
		xmlns='http://www.w3.org/2000/svg'
	>
		<title>skeptical</title>
		<path d='M7.54 12.41a1.63 1.63 0 111.63-1.63 1.63 1.63 0 01-1.63 1.63zm0-2.43a.81.81 0 10.81.8.81.81 0 00-.81-.78zM16.73 12.41a1.63 1.63 0 111.63-1.63 1.63 1.63 0 01-1.63 1.63zm0-2.43a.81.81 0 100 1.61.81.81 0 100-1.61z' />
		<path d='M12 23.36A11.36 11.36 0 1123.36 12 11.38 11.38 0 0112 23.36zm0-21.9A10.54 10.54 0 1022.54 12 10.55 10.55 0 0012 1.46z' />
		<path d='M14.49 8.86a.41.41 0 01-.3-.14.41.41 0 010-.58c.33-.3.48-.43.8-.7l.37-.32a2.9 2.9 0 012.71-.73 2.1 2.1 0 011.18 1.28.4.4 0 01-.22.53.41.41 0 01-.51-.2 1.28 1.28 0 00-.73-.85 2.15 2.15 0 00-1.87.61l-.37.32c-.31.26-.46.39-.78.68a.43.43 0 01-.28.1zM11.54 16.94a8.86 8.86 0 01-.95-.07.41.41 0 01.11-.82 3.94 3.94 0 001.42 0 2.78 2.78 0 001.11-.6.41.41 0 01.58.07.4.4 0 01-.07.57 3.7 3.7 0 01-1.43.76 3.5 3.5 0 01-.77.09z' />
	</svg>
);
